import type { Blot } from '../types';
import { findQuillByNode } from './findByNode';

export default function findQuillByBlot(blot: Blot) {
  const container = blot.scroll.domNode.parentElement;
  return container && findQuillByNode(container);
}
